// @ts-check
import DescriptionTextSetting from "Components/Common/Settings/DescriptionTextSetting";
import LogoBackgroundSetting from "Components/Common/Settings/LogoBackgroundSetting";
import SettingsBlock from "Components/Common/Settings/SettingsBlock";
import SwitcherSetting from "Components/Common/Settings/SwitcherSetting";
import TextInputSetting from "Components/Common/Settings/TextInputSetting";
import usersServerSettingsStore from "Stores/usersServerSettingsStore";
import { observer } from "mobx-react";
import React, { Component } from "react";

class DocUsersServerSettings extends Component {
    componentDidMount() {
        usersServerSettingsStore.LoadSettings()
    }

    render() {
        return ([
            <SettingsBlock
                id='stoplist-block'
                key='stoplist-block'
                title="Стоп-лист">

                <SwitcherSetting
                    key='add-to-stoplist-without-edsstamp'
                    title='Помещать в стоп-лист документ без визуального штампа ЭП'
                    helperText='Помещать в стоп-лист документ, где файл заверен электронной подписью, но визуализация штампа невозможна из-за ошибки коллажирования файла.'
                    value={usersServerSettingsStore.settings.addToStoplistWithoutEDSstamp}
                    onChanged={(value) => usersServerSettingsStore.SetAddToStoplistWithoutEDSstamp(value)} />

            </SettingsBlock>
            ,
            <SettingsBlock
                id='application-eds-block'
                key='application-eds-block'
                title="Электронная подпись">

                <SwitcherSetting
                    key='prohibit-sign-notavailable-edsfile'
                    title='Не заверять проект документа электронной подписью, если файл не отображается'
                    helperText='Запретить заверение ЭП проекта документа, если он содержит файл с установленным флагом «Применять ЭП», но не отображающийся в интерфейсе приложения.'
                    value={usersServerSettingsStore.settings.prohibitSignNotAvailableEdsFile}
                    onChanged={(value) => usersServerSettingsStore.SetProhibitSignNotAvailableEdsFile(value)} />

            </SettingsBlock>
            ,
            <SettingsBlock
                id='application-update-block'
                key='application-update-block'
                title="Обновление приложений">

                <SwitcherSetting
                    key='notify-new-version'
                    title='Уведомить устройства о появлении новой версии EOSmobile'
                    helperText='Данные уведомления доступны для iOS и Android приложений.'
                    disabled={usersServerSettingsStore.settings.notifyDeviceInfo.totalDevicesCount === 0}
                    value={usersServerSettingsStore.settings.notifyDeviceInfo.notifyNewVersion}
                    onChanged={(value) => usersServerSettingsStore.SetNotifyNewVersion(value)} />

                <DescriptionTextSetting
                    key='notify-new-version-result'
                    text={`Параметр включен для ${usersServerSettingsStore.settings.notifyDeviceInfo.notifiableDevicesCount} из ${usersServerSettingsStore.settings.notifyDeviceInfo.totalDevicesCount} устройств`} />

            </SettingsBlock>
            ,
            <SettingsBlock
                id='notification-block'
                key='notification-block'
                title="Уведомления">

                <SwitcherSetting
                    key='push-settings'
                    title="Push-уведомления:"
                    disabled={false}
                    value={usersServerSettingsStore.settings.enablePushNotification}
                    onChanged={(value) => usersServerSettingsStore.SetPushNotification(value)} />

            </SettingsBlock>
            ,
            <SettingsBlock
                id='sync-settings-block'
                key='sync-settings-block'
                title='Синхронизация'>

                <SwitcherSetting
                    key='disable-chain-validation'
                    title='Не проверять доверенность SSL-сертификатов'
                    value={usersServerSettingsStore.settings.mcDisableSslChainValidation}
                    onChanged={(value) => usersServerSettingsStore.SetMcDisableSslChainValidation(value)} />

            </SettingsBlock>
            ,
            <SettingsBlock
                id="organization-logo-settings-block"
                key="organization-logo-settings-block"
                title="Оформление рабочего стола">

                <LogoBackgroundSetting
                    key="logo-background-selection"
                    logo={usersServerSettingsStore.settings.logoFileData}
                    logoChanged={(value) => usersServerSettingsStore.SetLogo(value)}
                    background={usersServerSettingsStore.settings.backgroundFileData}
                    backgroundChanged={(value) => usersServerSettingsStore.SetBackground(value)} />

                <TextInputSetting
                    key="organization-name"
                    title="Наименование организации:"
                    value={usersServerSettingsStore.settings.customOrganisationName}
                    onChanged={(value) => usersServerSettingsStore.SetCustomOrganization(value)}
                    textOptions={{ maxLength: 50 }} />

            </SettingsBlock>
        ])
    }
}

export default observer(DocUsersServerSettings);